if (!customElements.get("nss-modal-wrapper")) {
    customElements.define(
        "nss-modal-wrapper",
        class NSSModalWrapper extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback() {
                const modal = this.querySelector("nss-modal");

                if (!modal) return;

                if (this.parentElement !== document.body) {
                    document.body.appendChild(modal);
                }
            }
        }
    );
}
if (!customElements.get("nss-modal")) {
    customElements.define(
        "nss-modal",
        class NSSModal extends HTMLElement {
            constructor() {
                super();

                this.selectors = {
                    trigger: ".js-nss-modal-trigger",
                    closeButton: ".js-nss-modal-close",
                    dialog: ".js-nss-modal-dialog",
                    video: ".js-nss-modal-video"
                };

                this.dataModal = this.getAttribute("data-modal");

                this.closeButton = this.querySelectorAll(this.selectors.closeButton);
                this.dialog = this.querySelector(this.selectors.dialog);
                this.video = this.querySelector(this.selectors.video);

                this.trigger = document.querySelectorAll(
                    `${this.selectors.trigger}[data-modal="${this.dataModal}"]`
                );

                this.allButtons = this.querySelectorAll("a, button");
                this.firstFocusableElement = this.allButtons[0];
                this.lastFocusableElement =
                    this.allButtons[this.allButtons.length - 1];

                this.html = document.documentElement;

                this.init();
            }

            /* ----------------------------
              Video helpers
            ---------------------------- */

            playVideo() {
                if (!this.video) return;

                if (this.video.tagName === "VIDEO") {
                    this.video.play();
                }

                if (this.video.tagName === "IFRAME") {
                    const src = this.video.getAttribute("src");
                    if (!src.includes("autoplay=1")) {
                        const join = src.includes("?") ? "&" : "?";
                        this.video.setAttribute("src", `${src}${join}autoplay=1`);
                    }
                }
            }

            stopVideo() {
                if (!this.video) return;

                if (this.video.tagName === "VIDEO") {
                    this.video.pause();
                    this.video.currentTime = 0;
                }

                if (this.video.tagName === "IFRAME") {
                    const src = this.video.getAttribute("src");
                    this.video.setAttribute("src", src);
                }
            }

            /* ----------------------------
              Modal controls
            ---------------------------- */

            openDialog() {
                this.classList.add("is-visible");
                this.html.classList.add("is-nss-modal-show");
                this.playVideo();
                this.closeButton[0]?.focus();
            }

            closeDialog() {
                this.classList.remove("is-visible");
                this.html.classList.remove("is-nss-modal-show");
                this.stopVideo();
                this.trigger[0]?.focus();
            }

            /* ----------------------------
              Init
            ---------------------------- */

            init() {
                // Open
                this.trigger.forEach(el => {
                    el.addEventListener("click", () => {
                        this.openDialog();
                    });
                });

                // Close button
                this.closeButton.forEach(el => {
                    el.addEventListener("click", () => {
                        this.closeDialog();
                    });
                });

                // Backdrop click
                this.addEventListener("click", (e) => {
                    if (!this.dialog.contains(e.target)) {
                        this.closeDialog();
                    }
                });

                // Escape key
                this.addEventListener("keydown", (e) => {
                    if (e.key === "Escape") {
                        this.closeDialog();
                    }
                });

                // Focus trap
                this.dialog?.addEventListener("keydown", (e) => {
                    if (
                        e.key === "Tab" &&
                        e.shiftKey &&
                        e.target === this.firstFocusableElement
                    ) {
                        e.preventDefault();
                        this.lastFocusableElement.focus();
                    }

                    if (
                        e.key === "Tab" &&
                        !e.shiftKey &&
                        e.target === this.lastFocusableElement
                    ) {
                        e.preventDefault();
                        this.firstFocusableElement.focus();
                    }
                });
            }
        }
    );
}
